enum EntityType {
	MENU = 'Menu',
	MENUPLAN = 'MenuPlan',
	RECIPE = 'Recipe',
	USERCHANGE = 'UserChange',
}

export default EntityType;
